import { Component, input, model, output } from '@angular/core';
import { Banner, BannerName } from '../../models/banner.model';
import { AsyncPipe, NgClass } from '@angular/common';
import { BannerService } from '@msslib/services';
import { Observable, switchMap } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: 'lib-banner',
  templateUrl: 'banner.component.html',
  styleUrls: ['banner.component.scss'],
  standalone: true,
  imports: [AsyncPipe, NgClass],
})
export class BannerComponent {
  public readonly maxWidth = input<string>('970px');
  public readonly maxHeight = input<string>();
  public readonly bannerName = input.required<BannerName>();
  public readonly withCloseButton = input(false);
  public readonly visible = model(true);
  public readonly content = input<'start' | 'center' | 'end'>();
  public readonly closeBanner = output();

  protected readonly banner$: Observable<Banner | undefined>;

  public constructor(bannerService: BannerService) {
    this.banner$ = toObservable(this.bannerName)
      .pipe(switchMap(bannerName => bannerService.getBannerByName(bannerName)));
  }

  public close() {
    this.visible.set(false);
    this.closeBanner.emit();
  }
}
